import {memo} from 'react';

import styled from 'styled-components';

import {PriceLabel} from '~/shared/components/PriceLabels';
import {NumericFormats} from '~/shared/consts/checkoutConsts';
import {getLocalizationService} from '~/shared/services/localisationService';
import {ComponentBySize, Title} from '~/shared/components/UserTransactions/shared';
import {DetailsBox, Text, Sum} from '~/shared/components/UserTransactions/components/styled';

const CardTitle = styled(Title)`
  margin-top: 0;
  font-size: 16px;
`;

const SingleDetailsBox = styled(DetailsBox)`
  ${({marginTop}) => marginTop && 'margin-top: 35px;'}
  width: calc(100% / 3 - 14px);
`;

const SingleDetailsBoxMobile = styled(DetailsBox)`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin: 0;
  ${({marginTop}) => marginTop && 'margin-top: 35px;'}
`;

const MobileWrapper = styled.div``;

const EmployerEmployeeCardDesktop = ({marginTop, employerPartSum, employeePartSum}) => {
  const {t} = getLocalizationService();

  return (
    <>
      <Title as="h3">{t('employer_participation')}</Title>

      <SingleDetailsBox marginTop={marginTop}>
        <>
          <Sum>
            <PriceLabel bold price={employerPartSum} formatString={NumericFormats.hideZeroDecimals} />
          </Sum>
          <Text spaceDown>{t('total_employer_part')}</Text>
          <Sum>
            <PriceLabel bold price={employeePartSum} formatString={NumericFormats.hideZeroDecimals} />
          </Sum>
          <Text>{t('total_employee_part')}</Text>
        </>
      </SingleDetailsBox>
    </>
  );
};
const EnhanceEmployerEmployeeCardDesktop = memo(EmployerEmployeeCardDesktop);

const EmployerEmployeeCardMobile = ({marginTop, employerPartSum, employeePartSum}) => {
  const {t} = getLocalizationService();
  return (
    <>
      <CardTitle as="h3">{t('employer_participation')}</CardTitle>
      <MobileWrapper>
        <SingleDetailsBoxMobile marginTop={marginTop}>
          <div>
            <Sum isMobile>
              <PriceLabel bold price={employerPartSum} formatString={NumericFormats.hideZeroDecimals} />
            </Sum>
            <Text isMobile>{t('total_employer_part')}</Text>
          </div>
          <div>
            <Sum isMobile>
              <PriceLabel bold price={employeePartSum} formatString={NumericFormats.hideZeroDecimals} />
            </Sum>
            <Text isMobile>{t('total_employee_part')}</Text>
          </div>
        </SingleDetailsBoxMobile>
      </MobileWrapper>
    </>
  );
};
const EnhanceEmployerEmployeeCardMobile = memo(EmployerEmployeeCardMobile);

const EmployerEmployeeCard = ({dateBias, marginTop, employeePartSum, employerPartSum}) => {
  const shouldRender = dateBias === 0 && (employeePartSum > 0 || employerPartSum > 0);
  if (!shouldRender) {
    return null;
  }

  return (
    <div>
      <ComponentBySize
        MobileComponent={EnhanceEmployerEmployeeCardMobile}
        DesktopComponent={EnhanceEmployerEmployeeCardDesktop}
        props={{employeePartSum, employerPartSum, marginTop}}
      />
    </div>
  );
};

export default memo(EmployerEmployeeCard);
